import styled from 'styled-components';

export const HeaderOuterWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #dff0ff;
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l75} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l60} ;

    @media only screen and (min-width:320px) and (max-width: 767px){
      padding: ${props.theme.spacing.large.l20} 0 ${props.theme.spacing.large.l20} 0 ;
      flex-direction: column;
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
        padding: ${props.theme.spacing.large.l20}
    }
    @media only screen and (min-width:1025px) and (max-width: 1300px){
        width: 100%;
        margin: 0 auto;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.base}
    }
  `,
)


export const LogoWrapper = styled.div(
    props => `
      width:60%;
      display: flex;

      @media only screen and (min-width:320px) and (max-width: 767px){
        width:100%;
        flex-direction: column;
        align-items: center;
      }
  
      @media only screen and (min-width:768px) and (max-width: 1024px){
        width:65%;
        flex-direction: row;
        align-items: center;
      }
    `,
);

export const TitleText = styled.div(
  props => `
    display: flex;
    align-items: center;
    padding-left: ${props.theme.spacing.large.l20};
    span {
      font-size: ${props.theme.font.large.font18};
      color: ${props.theme.colors.blue.dark};
      font-weight:${props.theme.font.fontWeight.bold};
      border-left: 1px solid ${props.theme.colors.grey.lightba};
      padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    }

    @media only screen and (min-width:320px) and (max-width: 767px){
      padding-left: 0;
      width: 100%;
      padding-top: ${props.theme.spacing.large.l15};
      span{
        width:100%;
        align-items: center;
        text-align: center;
        border-top:1px solid ${props.theme.colors.grey.lightba};
        border-bottom: 1px solid ${props.theme.colors.grey.lightba};
        border-left:none;
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.blue.dark};
        font-weight:${props.theme.font.fontWeight.bold};
        padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.large.l20};
        text-transform: uppercase;
      }
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      padding-left: ${props.theme.spacing.base};
      span{
        padding-left: ${props.theme.spacing.base};
      }
    }
  `,
);

export const LoginWrapper = styled.div(
  props => `
    width: 40%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @media only screen and (min-width:320px) and (max-width: 767px){
      width:100%;
      alig-items: center;
      justify-content: center;
      padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
        text-align: right;
        width:35%;
        flex-direction: row;
        align-items: center;
    }
  `,
)

export const MemberText = styled.p(
  props => `
    color: ${props.theme.colors.black.base};
    font-size: ${props.theme.font.base};
    text-transform: ${props.theme.font.textTransform.upper};
    margin-right: ${props.theme.spacing.base};
    @media only screen and  (min-width:320px) and (max-width: 767px){
      text-transform: ${props.theme.font.textTransform.none};
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
      text-transform: ${props.theme.font.textTransform.none};
    }
  `,
)


export const MemberLoginWrapper = styled.div(
  props => `
    display: flex;
    padding: 0 ${props.theme.spacing.base};
    background: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    align-items: center;
    :hover{
      color: ${props.theme.colors.blue.dark}
    }
  `,
);

export const MemberLoginText = styled.a(
  props => `
    color: ${props.theme.colors.blue.dark};
    font-size: ${props.theme.font.base};
    font-weight:${props.theme.font.fontWeight.black};
    padding:${props.theme.spacing.base};
    text-decoration: none;
    text-transform: ${props.theme.font.textTransform.upper};
    cursor: pointer;
    :hover{
        color: ${props.theme.colors.blue.dark}
    }
  `,
);


